import { Box, BoxProps } from "@chakra-ui/react";

export const Container: React.FC<BoxProps> = ({ children, ...otherProps }) => {
  return (
    <Box
      boxShadow=" 0px 0px 20px rgba(51, 102, 255, 0.15)"
      p="32px"
      rounded="32px"
      bg="white"
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      flex="1"
      {...otherProps}
    >
      {children}
    </Box>
  );
};
